module.exports = __webpack_public_path__ + "static/cafe-7bfa263199a439fbe8ac3617bfc662ec.jpg";